export default __webpack_public_path__ + "static/media/05-ART-(3-2).89956163.jpg";